import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ItemCategoryService, ItemsCategoryOutputDto, StoreResponseDto } from 'src/generated_client';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { SnackBarService } from 'src/app/services/snack-bar.service';


@Component({
  selector: 'app-categories-management',
  templateUrl: './categories-management.component.html',
  styleUrls: ['./categories-management.component.css']
})
export class CategoriesManagementComponent implements OnInit {

  displayedColumns: string[] = ['id', 'order', 'name', 'status', 'option'];
  allItems: ItemsCategoryOutputDto[] = [];
  storeResponse: StoreResponseDto = {} as StoreResponseDto;
  active: boolean = true;

  constructor(
    private router: Router,
    private categService: ItemCategoryService,
    private authService: AuthService,
    private snackBar: SnackBarService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.storeResponse = this.authService.currentUserStore();

    this.categService.apiItemCategoryGetAllGet(Number(this.storeResponse.cdStore)).subscribe(x => {
      this.allItems = x;
      this.allItems.sort((a, b) => (a.nmOrder! > b.nmOrder!) ? 1 : -1);
    })
  }

  changeCategoryStatus(id: number, isEnabled: boolean) {

    if (isEnabled) {

      const dialogRef = this.openDialog();

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {

        if (confirmed) {

          this.categService.apiItemCategoryChangeStatePut(id).subscribe(() => {

            this.router.navigate(['categories-management']);
            this.snackBar.openSnackBar('Los cambios fueron guardados correctamente', 'Aceptar')
          },
            err => {
              this.snackBar.openSnackBar(err.error.error, 'Aceptar');
            }
          );
        }
      });

    } else {

      this.categService.apiItemCategoryChangeStatePut(id, this.active).subscribe(response => {

        this.router.navigate(['categories-management']);
        this.snackBar.openSnackBar('Los cambios fueron guardados correctamente', 'Aceptar')
      },
        err => {
          this.snackBar.openSnackBar(err.error.error, 'Aceptar');
        }
      )
    }
  }

  private openDialog() {
    return this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: 'Se desactivarán los productos dentro de la categoría, Desea continuar?'
      }
    });
  }

  editCategory(id: number) {
    this.router.navigate(['edit-category', id]);
  }

  addCategory() {
    this.router.navigate(['add-category']);
  }

  deleteCategory(id: number) {

    this.categService.apiItemCategoryDeleteDelete(id).subscribe(response => {

      this.router.navigate(['categories-management']);

      this.snackBar.openSnackBar('Se eliminó correctamente.', 'Aceptar');
    },
      (err) => {
        this.snackBar.openSnackBar(err.error.error, 'Aceptar');
      })
  }
}
